import { getBlockSkipKey } from '../../helpers/blockSkipKey';

// Minimal shape needed to decide the key — accepts both the mapped
// CmsBaseComponent union and PageContent's CmsComponentProps.
type SkippableComponent =
  | { __typename?: string; id?: string | null }
  | null
  | undefined;

/**
 * Keys (see `getBlockSkipKey`) of Preferred Source Buttons that render nowhere:
 * every placed one when the flag is off, all but the first when on (CMS-2053).
 * Keys rather than a filtered array, so later blocks keep their content-N slots.
 */
export const getPreferredSourceButtonHiddenKeys = (
  components: readonly SkippableComponent[],
  show: boolean,
): string[] => {
  const buttons = components.filter(
    (component) =>
      component?.__typename ===
      'ComponentPagesComponentPreferredSourceButtonComponent',
  );
  return (show ? buttons.slice(1) : buttons).map((component) =>
    getBlockSkipKey(component),
  );
};
